<template>
    <navigation />

    <promo-header>
        <h1>
          {{ $t("home.heading") }}
        </h1>
    </promo-header>

    <section class="section section-white">

        <div class="container">

            <div class="row">

                <div class="col-md-6">

                    <h2 class="mb-4">
                      {{ $t("contact.title") }}
                    </h2>

                    <p>
                        {{ $t("enquiries.registeredCharity") }}
                    </p>

                    <p>
                        {{ $t("enquiries.charityRegistrationNumber") }} {{ $app.charityNumber }}
                    </p>

                    <p>
                        {{ $t("enquiries.correspondenceAddress") }}
                        <br />
                        47 Yew Tree Drive
                        <br />
                        Guildford
                        <br />
                        GU1 1PE
                        <br />
                        United Kingdom
                    </p>

                    <p>
                        {{ $t("enquiries.telephone") }}: {{ $app.phoneNumber }}
                    </p>

                    <iframe id="twitter-widget-0" scrolling="no" frameborder="0" allowtransparency="true"
                        class="twitter-follow-button twitter-follow-button-rendered"
                        style="position: static; visibility: visible; width: 156px; height: 28px;" title="Twitter Follow Button"
                        src="https://platform.twitter.com/widgets/follow_button.0639d67d95b7680840758b6833f06d87.en.html#dnt=true&amp;id=twitter-widget-0&amp;lang=en&amp;screen_name=bible4kids&amp;show_count=false&amp;show_screen_name=true&amp;size=l&amp;time=1566292292971"
                        data-screen-name="bible4kids">
                    </iframe>

                </div>

                <div class="col-md-6 mt-5 mt-md-0">

                    <h2 class="mb-4">
                      {{ $t("enquiries.enquiryForm") }}
                    </h2>

                    <p>
                      {{ $t("enquiries.useForm") }}
                    </p>

                    <contact-form
                        endpoint="/api/contact"
                        method="post"
                    />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script>
import PromoHeader from "../partials/PromoHeader.vue";
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import ContactForm from "../partials/ContactForm.vue";
import Products from "../partials/Products.vue";
import Pricing from "../partials/Pricing.vue";

export default {
    name: "Contact",

    components: {
        Navigation,
        Products,
        Pricing,
        SiteFooter,
        ContactForm,
        PromoHeader,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("contact.title")}`,
        };
    },
};
</script>
